import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api/v1`;

const TOKEN_KEY = "tsaas_token";
const USER_KEY = "tsaas_user";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};
export const getStoredUser = () => {
  const v = localStorage.getItem(USER_KEY);
  return v ? JSON.parse(v) : null;
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      clearToken();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

/**
 * Global safety net — an accidental unhandled axios rejection anywhere in the
 * app should NOT paint the React runtime error overlay. Consumers still handle
 * their own errors; this only prevents a total-crash regression.
 */
if (typeof window !== "undefined" && !window.__tsaasRejectionHandlerInstalled) {
  window.__tsaasRejectionHandlerInstalled = true;
  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    // Only silence axios-style rejections (they have `isAxiosError` or `response`)
    if (reason && (reason.isAxiosError || reason.response || reason.request)) {
      console.warn("[api] unhandled rejection swallowed:", reason?.message || reason);
      event.preventDefault();
    }
  });
}

/**
 * Safe error formatter — turns any FastAPI/axios error into a human-readable string.
 * Never returns an object (prevents "Objects are not valid as a React child" crashes).
 */
export const formatError = (err, fallback = "Something went wrong") => {
  try {
    if (!err) return fallback;
    if (typeof err === "string") return err;
    const data = err?.response?.data;
    if (!data) return err.message || fallback;
    if (typeof data === "string") return data;
    const d = data.detail ?? data.message ?? data.error ?? data;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
      // FastAPI validation error array
      return d.map((it) => {
        if (typeof it === "string") return it;
        const loc = Array.isArray(it?.loc) ? it.loc.filter((x) => x !== "body").join(".") : "";
        const msg = it?.msg || it?.message || "invalid value";
        return loc ? `${loc}: ${msg}` : msg;
      }).join(" · ");
    }
    if (typeof d === "object") {
      // Single error object
      return d.msg || d.message || JSON.stringify(d);
    }
    return fallback;
  } catch {
    return fallback;
  }
};
